import { createFileRoute, redirect } from "@tanstack/react-router"

export const Route = createFileRoute("/_dashboard/applications")({
  beforeLoad: ({ context: { store } }) => {
    if (store.getState().userRole !== "customer") {
      throw redirect({ to: "/" })
    }
  },
})
